import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EnumLabelPipe } from '../../pipes/enum-label.pipe';
import { CancelOperationComponent } from './components/cancel-operation/cancel-operation.component';
import { DurationTimerComponent } from './components/duration-timer/duration-timer.component';
import { LicensePlateItemDetailsCardComponent } from './components/license-plate-item-details-card/license-plate-item-details-card.component';
import { ScanBarcodeComponent } from './components/scan-barcode/scan-barcode.component';
import { ScanLocationComponent } from './components/scan-location/scan-location.component';

@NgModule({
  declarations: [
    DurationTimerComponent,
    ScanLocationComponent,
    ScanBarcodeComponent,
    CancelOperationComponent,
    LicensePlateItemDetailsCardComponent,
  ],

  imports: [FormsModule, CommonModule, EnumLabelPipe],
  exports: [
    DurationTimerComponent,
    ScanLocationComponent,
    ScanBarcodeComponent,
    CancelOperationComponent,
    LicensePlateItemDetailsCardComponent,
  ],
})
export class CommonComponentModule {}
